import styled, { css } from 'styled-components';
import { buttonDefaultProps } from './props';
import { withMargins } from '../../mixins';
const BUTTON_SIZES = {
    small: '32px',
    medium: '40px',
    large: '48px',
    'extra-large': '64px',
};
const withSizes = ({ size = buttonDefaultProps.size }) => {
    const sizes = {
        small: css `
      height: ${BUTTON_SIZES.small};
      padding: var(--spacing-1) var(--spacing-2);
      font-size: var(--font-size-xxs);
      line-height: var(--font-lineheight-tight);
    `,
        medium: css `
      height: ${BUTTON_SIZES.medium};
      padding: var(--spacing-1) var(--spacing-3);
      font-size: var(--font-size-xs);
      line-height: var(--font-lineheight-superdistant);
    `,
        large: css `
      height: ${BUTTON_SIZES.large};
      padding: var(--spacing-2) var(--spacing-3);
      font-size: var(--font-size-xs);
      line-height: var(--font-lineheight-supertight);
    `,
        'extra-large': css `
      height: ${BUTTON_SIZES['extra-large']};
      padding: var(--spacing-3) var(--spacing-4);
      font-size: var(--font-size-xs);
      line-height: var(--font-lineheight-supertight);
    `,
    };
    return sizes[size];
};
const withVariant = ({ variant = buttonDefaultProps.variant, }) => css `
    background-color: ${() => `var(--button-${variant}-background-color-base)`};
    border-color: ${() => `var(--button-${variant}-border-color-base)`};
    color: ${() => `var(--button-${variant}-color-font-base)`};

    :hover {
      background-color: ${() => `var(--button-${variant}-background-color-hover)`};
      border-color: ${() => `var(--button-${variant}-border-color-hover)`};
    }

    :focus {
      transition: outline 0ms, outline-offset 0ms;
      outline: var(--color-neutral-130) solid var(--border-width-thin);
      outline-offset: var(--border-width-thin);
    }

    :focus:not(:focus-visible) {
      outline: none;
      outline-offset: 0;
    }

    :active {
      transition: outline 0ms, outline-offset 0ms;
      border-color: transparent;
    }

    &.disabled {
      background-color: ${() => `var(--button-${variant}-background-color-disabled)`};
      border-color: ${() => `var(--button-${variant}-border-color-disabled)`};
      color: ${() => `var(--button-${variant}-color-font-disabled)`};
    }
  `;
const withTransition = () => {
    return css `
    :active {
      transition: all var(--transition-duration-1) var(--transition-timing-ease-in) 0ms, outline 0ms, outline-offset 0ms;
      transform: scale(0.96);
    }

    :not(:active) {
      transition: all var(--transition-duration-1) var(--transition-timing-ease-in) 0ms, outline 0ms, outline-offset 0ms;
    }

    :hover {
      transition: all var(--transition-duration-2) var(--transition-timing-ease-in) 0ms, outline 0ms, outline-offset 0ms;
    }

    :not(:hover) {
      transition: all var(--transition-duration-2) var(--transition-timing-ease-in) 0ms, outline 0ms, outline-offset 0ms;
    }
  `;
};
export const IconWrapper = styled.span `
  width: ${({ size }) => (size === 'small' ? 16 : 24)}px;
  height: ${({ size }) => (size === 'small' ? 16 : 24)}px;
  margin-right: var(--spacing-1);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  svg {
    fill: currentColor;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }
`;
export const IsLoadingWrapper = styled.span `
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ size }) => (size === 'small' ? 16 : 24)}px;
  height: ${({ size }) => (size === 'small' ? 16 : 24)}px;
`;
export const ContentWrapper = styled.div `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  visibility: ${({ isLoading }) => (isLoading ? 'hidden' : 'visible')};
`;
export const ButtonWrapper = styled.button `
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-width: 72px;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'fit-content')};
  border-style: solid;
  border-width: var(--border-width-hairline);
  outline: none;
  text-decoration: ${({ as }) => (as === 'a' ? 'none' : 'initial')};

  ${withSizes}
  ${withVariant}
  ${withMargins}
  ${withTransition}

  border-radius: var(--border-radius-pill);
  font-family: var(--font-family);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  &.disabled {
    cursor: not-allowed;
  }
`;
